"use client";
import LoadingWrapper, { LoadingProps } from "./loading-wrapper";
export default function FullPageLoading(props: LoadingProps) {
  return (
    <LoadingWrapper
      containerSx={{
        h: "100vh",
        w: "100vw",
      }}
      {...props}
    />
  );
}
